import { useCallback } from 'react';

import { StudyParticipant } from '../../models/StudyParticipant';
import { useHttpFetchApi } from '../http/useHttpFetch';

export function useGetUserStudyParticipants() {
  const { loading, error, getJson } = useHttpFetchApi();
  const getStudyParticipants = useCallback(
    (userId: number) => {
      return getJson<StudyParticipant[]>(`users/${userId}/study-participants`);
    },
    [getJson]
  );

  return {
    loadingStudyParticipants: loading,
    loadingStudyParticipantsError: error,
    getStudyParticipants
  };
}
